import { render } from "./DisplayProductComponent.vue?vue&type=template&id=1a289ea1&scoped=true"
import script from "./DisplayProductComponent.vue?vue&type=script&lang=js"
export * from "./DisplayProductComponent.vue?vue&type=script&lang=js"

import "./DisplayProductComponent.vue?vue&type=style&index=0&id=1a289ea1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\epentilescu\\source\\repos\\Delicitate V2\\front-end\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a289ea1"]])

export default __exports__